import { deClientPortalAssetDeviationAnalysis } from './AssetDetails/AssetDeviationAnalysis/AssetDeviationAnalysis'
import { deClientPortalAssetKeyValues } from './AssetDetails/AssetKeyValues/AssetKeyValues'
import { deClientPortalAssetPageLayout } from './AssetDetails/AssetPageLayout/AssetPageLayout'
import { deClientPortalAssetValuationList } from './AssetDetails/AssetValuationList/AssetValuationList'
import { deClientPortalValuationCommon } from './AssetDetails/Valuation'
import { deClientPortalValueCheckPages } from './AssetDetails/ValueCheck'

export const deClientPortalAssetDetailsCommon = {
    assetDetails: {
        assetPageLayout: deClientPortalAssetPageLayout,
        assetValuationList: deClientPortalAssetValuationList,
        assetKeyValues: deClientPortalAssetKeyValues,
        assetDeviationAnalysis: deClientPortalAssetDeviationAnalysis,
        valueCheck: deClientPortalValueCheckPages,
        valuation: deClientPortalValuationCommon,
    },
}
